"use client"
import React from 'react'
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion"
import Image from 'next/image';
import { useGetFaqs } from '@/lib/hooks/admin-dashboard/faq/get/useGetFaq';
const FAQDesktop = () => {
    const { data: faqData } = useGetFaqs()
    const faq = faqData as FAQ[] || []
    const sortedFaq = faq.sort((a, b) => Number(a.order) - Number(b.order))
    console.log("sorted faq: ", sortedFaq)
    return (
        <section className='flex flex-col sm:flex-row gap-10 justify-center px-2 sm:px-10 2xl:px-20'>
            <div className={`flex flex-col gap-4 text-[40px] sm:hidden`}>
                <h2>Frequently Asked Questions</h2>
            </div>
            <div className="hidden sm:flex flex-col gap-4 h-full">
                <div className='relative'>
                    <Image
                        src={'/assets/site/landing/desktop/service/service.webp'}
                        alt={"Services"}
                        height={1920}
                        width={1080}
                        className='object-cover w-[44rem]  rounded-lg'
                    />
                    <div className='absolute top-0 left-0 h-full w-full rounded-md bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-30 border border-gray-100' />
                    <div className='absolute top-0 left-0 h-full w-full flex px-4 gap-2 flex-col'>
                        <h2 className='text-[40px] xl:text-[50px] 2xl:text-8xl text-white font-bold'>Frequently</h2>
                        <h2 className='text-[40px] xl:text-[50px] 2xl:text-8xl text-white font-bold'>Asked</h2>
                        <h2 className='text-[40px] xl:text-[50px] 2xl:text-8xl text-white font-bold'>Questions</h2>
                    </div>
                </div>
            </div>
            <div className="px-2 w-full">
                <Accordion
                    type="single"
                    collapsible
                    className="w-full flex flex-col gap-4"
                >
                    {sortedFaq ? sortedFaq.map((item) => (
                        <AccordionItem value={item.id} key={item.id}>
                            <AccordionTrigger className="border px-4 py-4 rounded-lg w-full ">
                                <div className="flex items-center gap-2">
                                    <div className="bg-gr flex items-center justify-center h-8 w-8 rounded-full">
                                        <p style={{ color: "#ffffff" }}>{Number(item.order)+1}</p>
                                    </div>
                                    <p>{item.name}</p>
                                </div>
                            </AccordionTrigger>
                            <AccordionContent className="border p-2 mt-4">
                                {item.description}
                            </AccordionContent>
                        </AccordionItem>
                    )) : (
                        <div>No faq data found</div>
                    )}
                </Accordion>
            </div>
        </section>
    )
}

export default FAQDesktop